import { guid } from '@/mixins/guid';

const parent = '> .drzAccordion > .drzAccordion-section > .drzAccordion-section-content >';
const lastRowSelector = `${parent} .row:last-child, ${parent} .row:last-of-type, ${parent} .row:only-child, ${parent} .row:only-of-type`;

export default function accordion() {
  return {
    _id: false,
    type: 'puddle.accordion',
    isShared: false,
    templateRegion: false,
    lastRowSelector,
    search: false,
    arrow: false,
    sections: [
      {
        _id: guid.methods.guid(),
        title: 'Title',
        droplets: [],
        type: 'droplet.accordion.section',
      },
      {
        _id: guid.methods.guid(),
        title: 'Title',
        droplets: [],
        type: 'droplet.accordion.section',
      },
    ],
    mediaQueries: [
      {
        global: true,
        selector: '.drzAccordion',
        properties: [
          {
            property: 'transform',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
      {
        selector: lastRowSelector,
        properties: [
          {
            property: 'margin-bottom',
            desktop: '0px',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
      {
        selector: ', .drzAccordion',
        properties: [
          {
            property: 'display',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
      {
        selector: '.drzAccordion-section-title',
        properties: [
          {
            property: 'background-color',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
          {
            property: 'border-color',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
          {
            property: 'border-width',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
          {
            property: 'border-radius',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
      {
        selector: '.drzAccordion-section-title:hover',
        properties: [
          {
            property: 'background-color',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
      {
        selector: '.drzAccordion-section-content',
        properties: [
          {
            property: 'background-color',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
          {
            property: 'padding-left',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
          {
            property: 'padding-right',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
          {
            property: 'padding-top',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
          {
            property: 'padding-bottom',
            desktop: 'default',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
    ],
    pageCSS: '',
    bounceDroplet: false,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/accordion/droplet.schema.js